import { Routes, Route } from "react-router-dom";
import { SITE_ORIGIN } from "../../siteConfig";

import BangaloreNavbar from "../../branchPages/bangalorePage/bNavbar";
import BangaloreFooter from "../../branchPages/bangalorePage/bFooter";

import Bengalore from "../../branchPages/bangalorePage/bHero";
import BengaluruBranch from "../../separatePages/bengaluruBranch";
import AboutBangalore from "../../branchPages/bangalorePage/bAbout";
import HTinIndiaBangalore from "../../branchPages/bangalorePage/HTindia/htinIndia.jsx";
import HairTransplantCostIndiaBangalore from "../../branchPages/bangalorePage/HTindia/HTcostinIndia.jsx";
import HairTransplantSurgeryBangalore from "../../branchPages/bangalorePage/HTindia/HTsurgeryinIndia.jsx";
import AboutHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/aboutHT.jsx";
import MaleHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/maleHT.jsx";
import FemaleHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/femaleHT.jsx";
import BeardHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/beardHT.jsx";
import EyebrowHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/eyebrowHT.jsx";
import EyelashHairTransplantBangalore from "../../branchPages/bangalorePage/treatments/eyelashHT.jsx";
import FaqBangalore from "../../branchPages/bangalorePage/others/bangalorefaq.jsx";
import BangaloreTeam from "../../branchPages/bangalorePage/others/bangaloreteam.jsx";
import BangaloreTestimonials from "../../branchPages/bangalorePage/others/bangaloretestimonials.jsx";
import BangaloreTraining from "../../branchPages/bangalorePage/others/bangaloretraining.jsx";

function BangaloreLayout({ children }) {
  return (
    <>
      <BangaloreNavbar />
      {children}
      <BangaloreFooter />
    </>
  );
}

const u = (path) => `${SITE_ORIGIN}${path}`;

export default function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BangaloreLayout><Bengalore /></BangaloreLayout>} />
      <Route path="/bangalore.php" element={<BangaloreLayout><BengaluruBranch url={u("/bangalore.php")} /></BangaloreLayout>} />
      <Route path="/hair-transplant-in-bangalore.php" element={<BangaloreLayout><Bengalore /></BangaloreLayout>} />
      <Route path="/description.php" element={<BangaloreLayout><AboutBangalore /></BangaloreLayout>} />
      <Route path="/our-Surgeons.php" element={<BangaloreLayout><BangaloreTeam /></BangaloreLayout>} />
      <Route path="/hair-transplant-in-india.php" element={<BangaloreLayout><HTinIndiaBangalore /></BangaloreLayout>} />
      <Route path="/hair-transplant-cost-in-india.php" element={<BangaloreLayout><HairTransplantCostIndiaBangalore /></BangaloreLayout>} />
      <Route path="/hair-transplant-surgery-in-india.php" element={<BangaloreLayout><HairTransplantSurgeryBangalore /></BangaloreLayout>} />
      <Route path="/about-hair-transplants.php" element={<BangaloreLayout><AboutHairTransplantBangalore url={u("/about-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/male-hair-transplants.php" element={<BangaloreLayout><MaleHairTransplantBangalore url={u("/male-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/female-hair-transplants.php" element={<BangaloreLayout><FemaleHairTransplantBangalore url={u("/female-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/beard-hair-transplants.php" element={<BangaloreLayout><BeardHairTransplantBangalore url={u("/beard-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/eyebrow-hair-transplants.php" element={<BangaloreLayout><EyebrowHairTransplantBangalore url={u("/eyebrow-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/eyelash-hair-transplants.php" element={<BangaloreLayout><EyelashHairTransplantBangalore url={u("/eyelash-hair-transplants.php")} /></BangaloreLayout>} />
      <Route path="/trainings.php" element={<BangaloreLayout><BangaloreTraining url={u("/trainings.php")} /></BangaloreLayout>} />
      <Route path="/client-testimonials.php" element={<BangaloreLayout><BangaloreTestimonials url={u("/client-testimonials.php")} /></BangaloreLayout>} />
      <Route path="/faq.php" element={<BangaloreLayout><FaqBangalore url={u("/faq.php")} /></BangaloreLayout>} />
    </Routes>
  );
}